import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _RemoteAbstractAction, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";
import { PrintJson } from "../../../../../../theme/Component/PrintJson";
import { DocumentViewer } from "../../../../../../theme/Component/DocumentViewer";

interface Props {
    idApplicationInvoker: number,
    properties: any;
    data: any;
    setData: any;
    lastStep: boolean;
}
export const RemoteDocumentViewer = ({ idApplicationInvoker, properties, lastStep, data, setData }: Props) => {

    const { instance } = useDataBean(_RemoteAbstractAction);

    const [form, setForm] = useState<any>({});
    const [required, setRequired] = useState<any>([]);
    const [documents, setDocuments] = useState<any>([]);
    const [msg, setMsgList] = useState<any>([]);

    useEffect(() => {
        if (properties.AccountantDocument) {
            if (properties.AccountantDocument.DataBeanProperties) {
                const docs = properties.AccountantDocument.DataBeanProperties;
                setDocuments(docs.DocumentURL);
                if (docs.MsgList)
                    setMsgList(docs.MsgList);
            }
        }
    }, [properties])

    const handleChange = (e: any) => {
        setForm(_single.handleFormChange(form, e));
    }
    const fireEvent = (e: any, nameEvent) => {
        instance.fireAbstractStepEvent(idApplicationInvoker, nameEvent, form).then(
            (resp: any) => {
                setForm(resp);
            }
        ).catch(err => toast.error(err));

    }
    const submitForm = () => {
        if (setData)
            setData(form);
    }
    return (
        <div className="row">
            <div className="col-md-12">
                {msg.length > 0 ?
                    <div className="mt-4 p-2" style={{height:'60vh',overflow:'auto'}}>
                        <ul className="list-group">
                        {msg.map((item)=>{
                            return(
                                    <li className="list-group-item">{item}</li>
                            )
                        })}
                    </ul>
                    </div>
                    :
                    <DocumentViewer list={documents} />
                }
                {/* <PrintJson json={properties} /> */}
            </div>
            {!lastStep &&
                <div className="col-md-12">
                    <BasicButton icon="ri-send-plane-2-line" clase="primary" eventClick={submitForm}>Siguiente</BasicButton>
                </div>
            }
        </div>
    )
}